import { render, staticRenderFns } from "./email-verified.vue?vue&type=template&id=2ce64482&scoped=true"
import script from "./email-verified.vue?vue&type=script&lang=js"
export * from "./email-verified.vue?vue&type=script&lang=js"
import style0 from "./email-verified.vue?vue&type=style&index=0&id=2ce64482&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce64482",
  null
  
)

export default component.exports